import { render, staticRenderFns } from "./LocatorWidget.vue?vue&type=template&id=63937cc4&"
import script from "./LocatorWidget.vue?vue&type=script&lang=js&"
export * from "./LocatorWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports